import { Card } from '@occc-app/design-system';

type OfferEarningMechanismConfigurationSectionProps = {
  children: React.ReactNode;
};

export const OfferEarningMechanismConfigurationSection = ({
  children,
}: OfferEarningMechanismConfigurationSectionProps) => <Card sx={{ p: 3, mb: 2 }}>{children}</Card>;
